import type { AdminFinanceStats } from '../../../domain/superadmin/types';
import { formatCurrency } from '../../../utils/formatters';
import DashboardCard from '../../dashboard/components/DashboardCard';

type PastDueSectionProps = {
  items: AdminFinanceStats['pastDue'];
};

const formatPlanLabel = (plan: string | null) => {
  if (!plan) return '—';
  return plan.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

export function PastDueSection({ items }: PastDueSectionProps) {
  return (
    <section aria-label="Inadimplentes" className="mb-s5">
      <DashboardCard title="Inadimplentes">
        <p className="mb-s4 text-[12px] text-muted">
          Organizações com assinatura em atraso e MRR em risco
        </p>
        {items.length === 0 ? (
          <p className="rounded-lg border border-dashed border-border bg-surface px-s4 py-6 text-center text-[13px] text-muted">
            Nenhum inadimplente.
          </p>
        ) : (
          <ul className="flex flex-col gap-s2">
            {items.map((item) => (
              <li
                key={item.organizationId}
                className="flex flex-wrap items-center justify-between gap-s3 rounded-lg border border-warning/30 bg-warning-bg px-s4 py-3"
              >
                <div className="min-w-0">
                  <p className="text-[13px] font-medium text-default">{item.name}</p>
                  <p className="mt-0.5 text-[12px] text-muted">{formatPlanLabel(item.plan)}</p>
                </div>
                <span className="font-mono text-[13px] font-semibold tabular-nums text-warning-text">
                  {formatCurrency(item.mrrCents / 100, 'BRL')}
                </span>
              </li>
            ))}
          </ul>
        )}
      </DashboardCard>
    </section>
  );
}
